// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as RnrBannerView from "./RnrBannerView.bs.js";
import * as RnrRepoManager from "../domain/repo/RnrRepoManager.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import ReactIdSwiper from "react-id-swiper";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";

var end_flag_icon = RnrAssetManager.getImage("ended_icon.png");

var banner_english_end = RnrAssetManager.getImage("banner_english_end.png");

var banner_hindi_end = RnrAssetManager.getImage("banner_hindi_end.png");

var banner_kannada_end = RnrAssetManager.getImage("banner_kannada_end.png");

var banner_tamil_end = RnrAssetManager.getImage("banner_tamil_end.png");

var banner_telugu_end = RnrAssetManager.getImage("banner_telugu_end.png");

var banner_marathi_end = RnrAssetManager.getImage("banner_marathi_end.png");

function getContent(language) {
  var language$1 = Languages$Catalyst.fromCode(language);
  switch (language$1) {
    case /* English */0 :
        return {
                title: "Porter Reward Program has ended",
                subtitle: "Thank you for participating. A new Porter reward program will be announced shortly.",
                image_url: banner_english_end
              };
    case /* Hindi */1 :
        return {
                title: "पोर्टर रिवार्ड प्रोग्राम समाप्त हो गया है।",
                subtitle: "प्रोग्राम में भागीदार बनने के लिए धन्यवाद। शीघ्र ही एक नए पोर्टर रिवार्ड कार्यक्रम की घोषणा की जाएगी।",
                image_url: banner_hindi_end
              };
    case /* Kannada */2 :
        return {
                title: "ಪೋರ್ಟರ್ ರಿವಾರ್ಡ್ಸ್ ಕಾರ್ಯಕ್ರಮವು ಕೊನೆಗೊಂಡಿದೆ",
                subtitle: "ಭಾಗವಹಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ಹೊಸ ಪೋರ್ಟರ್ ರಿವಾರ್ಡ್ಸ್ ಕಾರ್ಯಕ್ರಮವನ್ನು ಶೀಘ್ರದಲ್ಲೇ ಘೋಷಿಸಲಾಗುವುದು.",
                image_url: banner_kannada_end
              };
    case /* Tamil */3 :
        return {
                title: "போர்ட்டர் வெகுமதி திட்டம் முடிவுபெற்றது",
                subtitle: "இதில் பங்குபெற்றதற்கு நன்றி! ஒரு புதிய வெகுமதி திட்டம் வெகு விரைவில் அறிவிக்கப்படும்",
                image_url: banner_tamil_end
              };
    case /* Telugu */4 :
        return {
                title: "పోర్టర్ రివార్డ్ ప్రోగ్రామ్ ముగిసింది",
                subtitle: "పాల్గొన్నందుకు ధన్యవాదాలు. కొత్త పోర్టర్ రివార్డ్ ప్రోగ్రామ్ త్వరలో ప్రకటించబడుతుంది.",
                image_url: banner_telugu_end
              };
    case /* Marathi */5 :
        return {
                title: "पोर्टर रिवॉर्ड कार्यक्रम संपला आहे।",
                subtitle: "सहभागी झाल्याबद्दल धन्यवाद। नवीन पोर्टर रिवॉर्ड कार्यक्रम लवकरच जाहीर केला जाईल।",
                image_url: banner_marathi_end
              };
    case /* Malayalam */6 :
    case /* Bangla */7 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "RnrCycleEndErrorCmp.res",
                18,
                2
              ],
              Error: new Error()
            };
    
  }
}

function RnrCycleEndErrorCmp$ImageBanner(Props) {
  var banners = Props.banners;
  return React.createElement(ReactIdSwiper, {
              wrapperClass: "banners-wrapper",
              containerClass: "banners-container",
              slideClass: "banner-slide",
              children: $$Array.of_list(List.mapi((function (ind, banner) {
                          return React.createElement("div", {
                                      key: String(ind)
                                    }, banner);
                        }), banners)),
              autoplay: {
                delay: 3000,
                disableOnInteraction: true
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                dynamicBullets: false
              }
            });
}

var ImageBanner = {
  make: RnrCycleEndErrorCmp$ImageBanner
};

function RnrCycleEndErrorCmp(Props) {
  var uuid = Props.uuid;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setBanners = match[1];
  React.useEffect((function () {
          var RepoInstance = RnrRepoManager.getRnrRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchRnrBanners, uuid, auth_token);
                }), (function (data) {
                  return Curry._1(setBanners, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (_error) {
                  
                }));
          
        }), []);
  var content = getContent(language);
  var bannersElements = RnrBannerView.getBanners(match[0], uuid);
  return React.createElement("div", {
              className: "c-reward-end-error"
            }, React.createElement("img", {
                  className: "reward-icon",
                  src: end_flag_icon
                }), React.createElement("div", {
                  className: "reward-title"
                }, content.title), React.createElement("div", {
                  className: "reward-subtitle"
                }, content.subtitle), List.length(bannersElements) > 1 ? React.createElement(RnrCycleEndErrorCmp$ImageBanner, {
                    banners: bannersElements
                  }) : (
                List.length(bannersElements) === 1 ? React.createElement("div", {
                        className: "banners-container"
                      }, List.hd(bannersElements)) : null
              ));
}

var make = RnrCycleEndErrorCmp;

export {
  end_flag_icon ,
  banner_english_end ,
  banner_hindi_end ,
  banner_kannada_end ,
  banner_tamil_end ,
  banner_telugu_end ,
  banner_marathi_end ,
  getContent ,
  ImageBanner ,
  make ,
  
}
/* end_flag_icon Not a pure module */
